TS.ns('WL');

WL.individualIncomeSourceViewModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;
        me.parent(config);

        var incomeSourcesList = me.getDomainProperty('dgIncomeSources_Property');
        if (incomeSourcesList != null) {
            incomeSourcesList.on('addNew', me.onIncomeSourceAdded);
        }

        var incomeSourceDetailsList = me.getDomainProperty('dgIncomeSourceDetails_Property');
        if (incomeSourceDetailsList != null) {
            incomeSourceDetailsList.on('addNew', me.onIncomeSourceDetailAdded);
        }

    },

    onIncomeSourceAdded: function (e) {
        var me = this,
         rec = e.item,
         owner = me._getOwner();

        rec.Details = ko.observableArray([]);
    },

    onIncomeSourceDetailAdded: function (e) {
        var me = this,
         rec = e.item,
         owner = me._getOwner();

        rec.DetailValues = ko.observableArray([]);
    }

});